"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.greaterThanEqualMatcherContext = void 0;
function greaterThanEqualMatcherContext(ruleAttr) {
    return function greaterThanEqualMatcher(runtimeAttr) {
        var isGreaterThanEqual = runtimeAttr >= ruleAttr;
        return isGreaterThanEqual;
    };
}
exports.greaterThanEqualMatcherContext = greaterThanEqualMatcherContext;
